import defaultPalette from '../theme/palette';
export default (function (_a) {
    var _b, _c, _d;
    var _e = _a.palette, palette = _e === void 0 ? defaultPalette : _e;
    return {
        MuiDataGrid: {
            root: {
                '& .MuiDataGrid-columnsContainer': {
                    backgroundColor: palette === null || palette === void 0 ? void 0 : palette.core[200],
                    color: (_b = palette === null || palette === void 0 ? void 0 : palette.common) === null || _b === void 0 ? void 0 : _b.black,
                },
                '& .MuiDataGrid-columnSeparator': {
                    display: 'none',
                },
                '& .MuiDataGrid-columnHeaderTitleContainer': {
                    padding: '0px',
                },
                '& .MuiDataGrid-row:nth-child(2n)': {
                    backgroundColor: palette === null || palette === void 0 ? void 0 : palette.grey[300],
                },
                '& .MuiSvgIcon-fontSizeSmall': {
                    color: (_c = palette === null || palette === void 0 ? void 0 : palette.common) === null || _c === void 0 ? void 0 : _c.black,
                },
                '& .MuiDataGrid-menuIcon': {
                    visibility: 'visible',
                    opacity: 0.5,
                },
                '& .MuiDataGrid-columnHeader:hover .MuiDataGrid-menuIcon': {
                    opacity: 1,
                },
                '& .MuiDataGrid-menuOpen.MuiDataGrid-menuIcon': {
                    opacity: 1,
                },
                '& .MuiDataGrid-sortIcon': {
                    color: (_d = palette === null || palette === void 0 ? void 0 : palette.common) === null || _d === void 0 ? void 0 : _d.black,
                },
                '&&& .MuiDataGrid-sortIcon': {
                    opacity: 0.5,
                },
                '&&& .MuiDataGrid-columnHeader:hover .MuiDataGrid-sortIcon': {
                    opacity: 1,
                },
                '&&& .MuiDataGrid-columnHeader--sorted .MuiDataGrid-sortIcon': {
                    opacity: 1,
                },
            },
        },
    };
});
